import { useSelector } from 'react-redux';
import Global from '../store/global-selectors';
import { doesServiceSupportSameDayFeature } from './use-is-service-local-delivery';

export const areLocalDeliveryServicesAvailableForSeller = (state, sellerServices) => {
  return sellerServices.some(doesServiceSupportSameDayFeature);
};

export const useAreLocalDeliveryServicesAvailableForSeller = () => {
  const sellerServices = useSelector(Global.selectSellerServices);
  return useSelector((state) => areLocalDeliveryServicesAvailableForSeller(state, sellerServices));
};
